import { jsx as s, jsxs as b, Fragment as d } from "react/jsx-runtime";
import _, { forwardRef as y, useId as p, isValidElement as f, cloneElement as w } from "react";
import { c as o } from "./clsx-OuTLNxxd.js";
import { a as u } from "./Tooltip-DVM2gMXz.js";
import "./Table.css?__remix_sideEffect__";const H = "320px",W = "600px",z = "1025px",C = "_isVisuallyHidden_1e1sw_52",S = "_tableGroup_1e1sw_64",B = "_table_1e1sw_64",T = "_tableLabel_1e1sw_78",N = "_tableWrapper_1e1sw_96",R = "_tableCaption_1e1sw_114",v = "_tableRow_1e1sw_131",F = "_tableHeader_1e1sw_135",D = "_tableColumn_1e1sw_135",G = "_tableBody_1e1sw_145",I = "_tableCell_1e1sw_145",j = "_tableFooter_1e1sw_147",k = "_highlight_1e1sw_167",L = "_showDividers_1e1sw_201",V = "_cellWrapper_1e1sw_237",$ = "_headingText_1e1sw_164",E = "_columnWrapper_1e1sw_240",e = {
    mobile: H,
    "mobile-wide": "480px",
    tablet: W,
    "tablet-wide": "800px",
    desktop: z,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: C,
    tableGroup: S,
    table: B,
    tableLabel: T,
    tableWrapper: N,
    tableCaption: R,
    tableRow: v,
    tableHeader: F,
    "tableRow-size--s": "_tableRow-size--s_1e1sw_135",
    tableColumn: D,
    "tableRow-size--m": "_tableRow-size--m_1e1sw_139",
    tableBody: G,
    tableCell: I,
    tableFooter: j,
    "headingText--mobile": "_headingText--mobile_1e1sw_164",
    highlight: k,
    showDividers: L,
    "highlight--green": "_highlight--green_1e1sw_220",
    "highlight--amber": "_highlight--amber_1e1sw_224",
    "highlight--red": "_highlight--red_1e1sw_228",
    "mobile-hide": "_mobile-hide_1e1sw_232",
    cellWrapper: V,
    headingText: $,
    columnWrapper: E
  },M = ({
    children: i,
    className: l,
    row: t,
    ...a
  }) => /* @__PURE__ */s(
    "thead",
    {
      className: o(e.tableHeader, l),
      style: { "--gridRow": t },
      ...a,
      children: i
    }
  ),O = ({ children: i, className: l, ...t }) => /* @__PURE__ */s("tbody", { className: o(e.tableBody, l), ...t, children: i }),P = ({
    children: i,
    className: l,
    ...t
  }) => /* @__PURE__ */s("tfoot", { className: o(e.tableFooter, l), ...t, children: i }),Q = ({
    children: i,
    className: l,
    size: t = "m",
    ...a
  }) => /* @__PURE__ */s(
    "tr",
    {
      className: o(
        e.tableRow,
        e[`tableRow-size--${t}`],
        l
      ),
      ...a,
      children: i
    }
  ),U = ({
    children: i,
    className: l,
    ...t
  }) => /* @__PURE__ */s("caption", { className: o(e.tableCaption, l), ...t, children: i }),X = ({
    alignItems: i = "center",
    children: l,
    className: t,
    highlight: a,
    justifyContent: n = "flex-start",
    mobileView: c,
    mobileText: x,
    showDividers: h,
    toolTipSide: g,
    tooltipText: r,
    ...m
  }) => /* @__PURE__ */s(
    "th",
    {
      className: o(
        e.tableColumn,
        e[`mobile-${c}`],
        {
          [e.highlight]: a,
          [e.showDividers]: h
        },
        t
      ),
      ...m,
      children: /* @__PURE__ */b(
        "div",
        {
          className: e.columnWrapper,
          style: {
            "--alignItems": i,
            "--justifyContent": n
          },
          children: [
          x ? /* @__PURE__ */b(d, { children: [
            /* @__PURE__ */s("span", { className: e["headingText--mobile"], children: x }),
            /* @__PURE__ */s("span", { className: e.headingText, children: l })]
          }) : /* @__PURE__ */s(d, { children: l }),
          r && /* @__PURE__ */s(u, { side: g, children: r })]

        }
      )
    }
  ),Y = ({
    alignItems: i = "center",
    children: l,
    highlight: t,
    justifyContent: a = "flex-start",
    showDividers: n,
    className: c,
    style: x,
    ...h
  }) => /* @__PURE__ */s(
    "td",
    {
      style: {
        ...x,
        "--alignItems": a,
        "--justifyContent": i
      },
      className: o(
        e.tableCell,
        {
          [e.highlight]: t,
          [e[`highlight--${t}`]]: t,
          [e.showDividers]: n
        },
        c
      ),
      ...h,
      children: /* @__PURE__ */s("div", { className: e.cellWrapper, children: l })
    }
  ),Z = y(
    ({ children: i, mobileColumns: l, className: t, ...a }, n) => /* @__PURE__ */s("div", { className: e.tableWrapper, children: /* @__PURE__ */s("table", { ref: n, className: o(e.table, t), ...a, children: i }) })
  ),ee = ({ children: i, label: l, className: t }) => {
    const a = p(),n = _.Children.map(
        i,
        (c) => f(c) ? w(c, {
          "aria-labelledby": a
        }) : c
      );
    return /* @__PURE__ */b("div", { className: o(e.tableGroup, t), children: [
      l && /* @__PURE__ */s("h3", { className: e.tableLabel, id: a, children: l }),
      n]
    });
  };
export {
  Z as T,
  ee as a,
  U as b,
  M as c,
  O as d,
  P as e,
  Q as f,
  Y as g,
  X as h };